<template>
  <fieldset class="tab tab-04 none-bg">
    <div class="heading-form a-center">
      <span class="number">4/18</span>
      <p class="c-yellow">การออกกำลังกายและพักผ่อน</p>
      <h2 class="heading-h2 c-white">
        เดือนที่ผ่านมา คุณนอนเฉลี่ยวันละกี่ชั่วโมง
      </h2>
    </div>
    <div class="icw-fieldset-inner">
      <ul class="icw-fields">
        <li class="icw-field icw-field-full">
          <div class="icw-input icw-input-checkbox" id="rdoAvgSleep">
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="radio4"
                id="L6hour"
                class="css-checkbox"
                value="less6hour"
                v-model="sleep_time"
              />
              <label for="L6hour" class="css-label">น้อยกว่า 6 ชั่วโมง</label>
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="radio4"
                id="6hour"
                class="css-checkbox"
                value="6hour"
                v-model="sleep_time"
              />
              <label for="6hour" class="css-label">6 ชั่วโมง</label>
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="radio4"
                id="7hour"
                class="css-checkbox"
                value="7hour"
                v-model="sleep_time"
              />
              <label for="7hour" class="css-label">7 ชั่วโมง</label>
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="radio4"
                id="8hour"
                class="css-checkbox"
                value="8hour"
                v-model="sleep_time"
              />
              <label for="8hour" class="css-label">8 ชั่วโมง</label>
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="radio4"
                id="O8hour"
                class="css-checkbox"
                value="more8hour"
                v-model="sleep_time"
              />
              <label for="O8hour" class="css-label">มากกว่า 8 ชั่วโมง</label>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="icw-fieldset-action previous">
      <button
        type="button"
        class="btn btn-previous previous"
        @click="checkBeforePrevious()"
      >
        ย้อนกลับ
      </button>
      <!-- <button v-if="!skipHealthWorkOut()" type="button" class="btn btn-previous previous" @click="prevStep('tab-04', 'tab-03')">ย้อนกลับ</button> -->
      <!-- <button v-else type="button" class="btn btn-previous previous" @click="prevStep('tab-04', 'tab-01')">ย้อนกลับ</button> -->
    </div>
    <button
      id="btnNextStepQ5"
      type="button"
      class="btn btn-next next"
      :class="{ 'btn-disabled': !isPass }"
      @click="beforeNextStep()"
    >
      ถัดไป
    </button>
  </fieldset>
</template>

<script>
import Vue from "vue";

import { my_storage } from "@/helpers/global_helper.js";
import { nextStep, prevStep } from "@/helpers/step_helper.js";

export default {
  name: "QuestionStep3_Q4",
  props: {
    QuestionType: String
  },
  data() {
    return {
      sleep_time: my_storage(this.QuestionType, "sleep_time")
    };
  },
  methods: {
    my_storage,
    nextStep,
    prevStep,
    checkBeforePrevious() {
      let a = JSON.parse(sessionStorage.getItem("WorkoutRate"));
      if (a == null) {
        this.prevStep("tab-04", "tab-01");
      } else if (a.workout_rate == "1") {
        this.prevStep("tab-04", "tab-03");
      } else if (!this.skipHealthWorkOut()) {
        this.prevStep("tab-04", "tab-02");
      } else {
        this.prevStep("tab-04", "tab-01");
      }
    },
    skipHealthWorkOut() {
      let found = false;
      let check = my_storage("Healthy", "healthy");
      if (check.indexOf("exercise") == -1) {
        found = true;
      } else {
        found = false;
      }
      return found;
    },
    beforeNextStep() {
      if (this.sleep_time != "") {
        sessionStorage.setItem(this.QuestionType, JSON.stringify(this._data));
        this.nextStep("tab-04", "tab-05");
      }
    }
  },
  computed: {
    isPass() {
      return this.sleep_time != "";
    }
  }
};
</script>
